import React from 'react';

import cs from 'classnames';
import { procedureTypes } from 'constants';

import { ia } from 'lib/helpers/utility';

import { handleProcedureType } from 'components/practice/appointment/appointmentHelpers';
import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';
import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';
import InputOptions from 'components/shared/InputOptions/InputOptions';

import {
  handleChangePackageQuantity,
  handleChangePrice,
  handleChangeQuantity,
  handleChangeUnitPrice,
  removeItem
} from '../lib';

const SelectedItems = ({ selectedItems = [], type = '', label = '', formik }) => {
  const { errors, setFieldValue } = formik;

  return (
    <>
      {ia(selectedItems) && selectedItems[0]?.id && (
        <div className="my-4 flex flex-col gap-2">
          {selectedItems.map((item, i) => {
            const { name, quantity, sales_count, procedure_code } = item || {};

            return (
              <div className="flex items-start gap-[10px]" key={i}>
                <div className={cs('grid w-full', type === 'procedures' && 'min-w-[70%]')}>
                  {i === 0 && <p className="mb-[6px] text-sm font-500 text-neutral-800">{label}</p>}

                  <div
                    className={cs(
                      'flex h-10 items-center justify-between rounded-md !border border-solid border-neutral-100 bg-neutral-50 !px-3 !py-2'
                    )}>
                    <div className="grid overflow-hidden">
                      <p
                        title={name}
                        className="flex items-center truncate text-sm text-neutral-800">
                        {name}
                      </p>
                    </div>

                    {type === 'services' && !item?.packageId && ia(procedureTypes) && (
                      <InputOptions
                        position="top"
                        options={
                          procedure_code
                            ? procedureTypes
                            : procedureTypes.filter((t) => t?.value !== 'primary')
                        }
                        currentOption={
                          procedureTypes.find(
                            (o) => o?.value === (item?.type === 'cash' ? 'self_pay' : item?.type)
                          )?.label
                        }
                        onClickOption={(option) =>
                          handleProcedureType(setFieldValue, selectedItems, i, option, type)
                        }
                      />
                    )}
                  </div>
                </div>

                {type === 'products' && (
                  <CurrencyInput
                    label={i === 0 && 'Unit Price'}
                    value={item?.total_amount_cents}
                    onValueChange={(v) =>
                      handleChangeUnitPrice(setFieldValue, selectedItems, v, item?.id)
                    }
                    disabled={true}
                  />
                )}

                {(type === 'services' || type === 'products') && (
                  <Input
                    min={1}
                    type="number"
                    id={quantity + i}
                    inputClassName="!w-8"
                    value={type === 'products' ? sales_count : quantity || 1}
                    label={i === 0 && 'Qty'}
                    className="-mt-1"
                    onChange={(e) => {
                      handleChangeQuantity(
                        setFieldValue,
                        selectedItems,
                        e.target.value,
                        item?.id,
                        quantity,
                        type
                      );
                    }}
                  />
                )}

                {type === 'products' && (
                  <CurrencyInput
                    label={i === 0 && 'Price'}
                    id={`total_amount_cents-${i}`}
                    value={item?.total_amount_cents}
                    onValueChange={(v) =>
                      handleChangePrice(type, setFieldValue, selectedItems, v, item?.id)
                    }
                    disabled={true}
                  />
                )}

                {type === 'packages' && (
                  <>
                    <CurrencyInput
                      label={i === 0 && 'Unit Price'}
                      value={item?.amount_cents}
                      onValueChange={(v) =>
                        handleChangeUnitPrice(setFieldValue, selectedItems, v, item?.id)
                      }
                      disabled={true}
                      error={errors?.products && errors?.products[i]?.amount_cents}
                    />

                    <Input
                      min={1}
                      id={sales_count + i}
                      type="number"
                      inputClassName="!w-8"
                      value={sales_count}
                      hideNumberArrows={false}
                      label={i === 0 && 'Qty'}
                      className="-mt-1"
                      onChange={(e) =>
                        handleChangePackageQuantity(
                          type,
                          setFieldValue,
                          selectedItems,
                          e.target.value,
                          item?.id
                        )
                      }
                    />

                    <CurrencyInput
                      label={i === 0 && 'Price'}
                      id={`total_amount_cents-${i}`}
                      value={item?.total_amount_cents}
                      disabled={true}
                      error={errors?.products && errors?.products[i]?.total_amount_cents}
                    />
                  </>
                )}

                <Icon
                  icon="trash-mono"
                  className={i === 0 ? 'pt-[39px]' : 'pt-[12px]'}
                  onClick={() => removeItem(setFieldValue, selectedItems, type, i)}
                />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default SelectedItems;
